import { ReactElement, ReactNode } from 'react'
import { AstPunchOutContext } from './astPunchOut/AstPunchOutStore'
import { JobsCatalogContext } from './jobs/JobsStore'
import { BannerPromotionContext } from './promotion/BannerPromotionStore'
import { SearchStoreContext } from '../store/search/SearchStore'
import { SpecificConditionsContext } from './specificConditions/SpecificConditionsStore'
import { StoreInstances } from './StoreInstancesContainer'
import { PartsCatalogContext } from './partsCatalog/PartsCatalog'
import { LaborLookupContext } from './labor/LaborStore'
import { UiStateStoreContext } from './uiState/UiStateStore'
import { UserStoreContext } from './user/UserStore'
import { LanguageContextStore } from 'common'
import { VehicleMakesStoreContext } from '../features/search/VehicleSearch/store/VehicleMakesStore'
import { QuoteContext } from 'pages/quotes/src/store/QuoteStore'

export const Store = ({ children }: { children: ReactNode }): ReactElement => {
  StoreInstances.init()
  return (
    <UiStateStoreContext.Provider value={StoreInstances.uiStore}>
      <UserStoreContext.Provider value={StoreInstances.userStore}>
        <SearchStoreContext.Provider value={StoreInstances.searchStore}>
          <VehicleMakesStoreContext.Provider
            value={StoreInstances.vehicleMakesStore}
          >
            <AstPunchOutContext.Provider
              value={StoreInstances.astPunchOutStore}
            >
              <JobsCatalogContext.Provider value={StoreInstances.jobsCatalog}>
                <PartsCatalogContext.Provider
                  value={StoreInstances.partsCatalog}
                >
                  <LaborLookupContext.Provider
                    value={StoreInstances.laborStore}
                  >
                    <SpecificConditionsContext.Provider
                      value={StoreInstances.specificConditions}
                    >
                      <LanguageContextStore>
                        <BannerPromotionContext.Provider
                          value={StoreInstances.bannerPromotionStore}
                        >
                          <QuoteContext.Provider
                            value={StoreInstances.quoteStore}
                          >
                            {children}
                          </QuoteContext.Provider>
                        </BannerPromotionContext.Provider>
                      </LanguageContextStore>
                    </SpecificConditionsContext.Provider>
                  </LaborLookupContext.Provider>
                </PartsCatalogContext.Provider>
              </JobsCatalogContext.Provider>
            </AstPunchOutContext.Provider>
          </VehicleMakesStoreContext.Provider>
        </SearchStoreContext.Provider>
      </UserStoreContext.Provider>
    </UiStateStoreContext.Provider>
  )
}
